import { Component } from '@angular/core';
import { DepartmentsListComponent } from '../../../../components/admin-dashboard-component/departments-component/departments-list-component/departments-list-component';

@Component({
  selector: 'app-departments-list',
  imports: [DepartmentsListComponent],
  templateUrl: './departments-list.html',
  styleUrl: './departments-list.scss',
})
export class DepartmentsList {}
